import * as types from './types'
import globals from '@/plugins/globals.js'

export default {
  [types.SET_TOOLS](state, data) {
    state.tools = data
    state.tools.forEach(element => {
      element.connected = false
      element.elapsedTime = globals.elapsedTime(element.lastEditedTime, 'not used')
      element.connectedTo = null
      element.serviceRequestId = null
      element.tech = null
    })
  },
  [types.RESET_TOOLS](state, data) {
    state.shopDevices = []
    data.forEach(element => {
      element.isTool = false
      element.connectedTo = null
      element.serviceRequestId = null
      element.tech = null
      element.location = null
    })
    state.tools.forEach(tool => {
      data.forEach(element => {
        if (parseInt(element.serialNumber) === parseInt(tool.serialNumber)) {
          tool.connected = true
          element.isTool = true
        }
      })
    })
    data.forEach(element => {
      if (!element.isTool) {
        state.shopDevices.push(element)
      }
    })
  },
  [types.SET_HUB_DATA](state, data) {
    if (data !== undefined && data !== null) {
      switch (data.action) {
        case 'set':
          if (data.type === 'tool') {
            state.hubData.tool.info.id = data.info.id
            state.hubData.tool.info.friendlyName = data.info.friendlyName
            state.hubData.tool.info.serialNumber = data.info.serialNumber
          } else { // device
            state.hubData.device.info.id = data.info.id
            state.hubData.device.info.friendlyName = data.info.friendlyName
            state.hubData.device.info.serialNumber = data.info.serialNumber
          }
          break
        case 'reset':
          state.hubData.status = ''
          if (data.type === 'tool') {
            state.hubData.tool.status = 'restarting'
          } else { // device
            state.hubData.device.status = 'restarting'
          }
          break
        case 'pair':
          if (data.status === 'failed') {
            state.hubData.tool.status = 'failed'
            state.hubData.device.status = 'failed'
            state.hubData.status = ''
          } else { // paired
            state.hubData.tool.status = 'paired'
            state.hubData.device.status = 'paired'
            state.hubData.status = 'paired'
          }
          break
        case 'repair':
          state.hubData.pair = null
          if (data.info !== undefined && data.info !== null) {
            if (parseInt(state.hubData.device.info.serialNumber) === parseInt(data.info.shopSerialNumber)) {
              if (state.hubData.status === 'paired') {
                state.hubData.device.status = 'paired'
              } else {
                state.hubData.device.status = 'connected'
              }
            }
            if (parseInt(state.hubData.tool.info.serialNumber) === parseInt(data.info.toolSerialNumber)) {
              if (state.hubData.status === 'paired') {
                state.hubData.tool.status = 'paired'
              } else {
                state.hubData.tool.status = 'connected'
              }
            }
          }
          break
        case 'unpair':
          state.hubData.tool.status = 'unpaired'
          state.hubData.device.status = 'unpaired'
          state.hubData.status = ''
          break
        case 'connect':
          if (data.type === 'tool') {
            state.hubData.tool.status = data.status
          } else { // device
            state.hubData.device.status = data.status
          }
          break
        case 'disconnect':
          if (state.hubData.status === 'paired') {
            state.hubData.status = ''
            if (data.type === 'tool') {
              state.hubData.tool.status = 'disconnected'
              state.hubData.device.status = 'connected'
            } else { // device
              state.hubData.device.status = 'disconnected'
              state.hubData.tool.status = 'connected'
            }
          } else {
            if (data.type === 'tool') {
              state.hubData.tool.status = 'disconnected'
            } else { // device
              state.hubData.device.status = 'disconnected'
            }
          }
          break
        case 'info':
          if (data.type === 'tool') {
            // state.hubData.tool.info = data.info
          } else { // device
            state.hubData.device.info.armFirmware = data.info.armFirmware
            state.hubData.device.info.hwRevision = data.info.hwRevision
            state.hubData.device.info.isWifi = data.info.isWifi
            state.hubData.device.info.ppcFirmware = data.info.ppcFirmware
            state.hubData.device.info.serialNumber = data.info.serialNumber
            state.hubData.device.info.vin = data.info.vin
            state.hubData.device.status = 'connected'
          }
          break
        case 'stats':
          if (data.info === null) {
            state.hubData.device.stats = {
              isAvailable: false,
              v: 0,
              rtt: 0,
              rssi: '',
              rx: 0,
              tx: 0
            }
          } else {
            state.hubData.device.stats = data.info
          }
          break
        case 'clear':
          state.hubData = state.cleanHubData
          break
        case 'error':
          state.hubData.error = data.info
          break
      }
    }
  },
  [types.SET_INTERVAL](state, interval) {
    state.statisticInterval = interval
  },
  [types.SET_CONNECTED_DEVICES](state, devices) {
    state.connectedDevices = devices
  },
  [types.SET_MONITOR_INFO](state, data) {
    state.hubData.pairInfo = {
      appLayerInterface: 0,
      appLayerProtocol: 0,
      serviceRequestId: 0,
      shopSerialNumber: 0,
      toolSerialNumber: 0
    }
    state.requests = []
    state.techs = []
    state.tools.forEach(tool => {
      tool.connectedTo = null
      tool.serviceRequestId = null
      tool.tech = ''
    })
    state.shopDevices.forEach(device => {
      device.connectedTo = null
      device.serviceRequestId = null
      device.tech = ''
      device.location = null
    })
    if (data !== undefined && data !== null) {
      state.techs = data.techs
      state.techs.forEach(element => {
        element.elapsedTime = globals.elapsedTime(element.lastEditedTime, 'awol')
        element.serviceRequestId = null
      })
      if (data.tools !== null) {
        if (data.tools.length > 0) {
          data.tools.forEach(element => {
            state.tools.forEach(tool => {
              if (parseInt(tool.serialNumber) === parseInt(element.HostSerialNumber)) {
                tool.connectedTo = parseInt(element.ShopSerialNumber)
                tool.serviceRequestId = parseInt(element.ServiceRequestId)
              }
            })
            state.shopDevices.forEach(device => {
              if (parseInt(device.serialNumber) === parseInt(element.ShopSerialNumber)) {
                device.connectedTo = parseInt(element.HostSerialNumber)
                device.serviceRequestId = parseInt(element.ServiceRequestId)
              }
            })
          })
        } else {
          state.hubData.pairInfo = {
            appLayerInterface: 0,
            appLayerProtocol: 0,
            serviceRequestId: data.items[0].serviceRequestId,
            shopSerialNumber: data.items[0].ShopSerialNumber,
            toolSerialNumber: data.items[0].HostSerialNumber
          }
        }
      }
      if (data.requests !== null) {
        state.requests = data.requests
        if (state.requests.length > 0) {
          state.requests.forEach(request => {
            request.elapsedTime = globals.elapsedTime(request.createdDate, '')
            request.toolName = null
            request.isChatting = false
            request.isChat = false
            request.isEditingStatus = false
            if (request.masterTech === null) {
              request.masterTech = ''
            }
            state.tools.forEach(tool => {
              if (request.workOrderId === tool.serviceRequestId) {
                tool.tech = request.masterTech
                request.toolName = tool.friendlyName
              } else if (parseInt(request.toolId) === parseInt(tool.id)) {
                request.toolName = tool.friendlyName
              }
            })
            state.shopDevices.forEach(device => {
              if (request.vin === device.vin || request.workOrderId === device.serviceRequestId) {
                device.location = request.location
                device.tech = request.masterTech
              }
            })
            state.techs.forEach(tech => {
              if (request.userId === tech.id) {
                tech.serviceRequestId = request.workOrderId
              }
            })
            state.waitingChats.forEach((channel, idx) => {
              if (request.workOrderId === parseInt(channel) && (request.status === 'Waiting on Shop' || request.status === 'Submitted')) {
                request.isChat = true
              } else if (request.workOrderId === parseInt(channel)) {
                state.waitingChats.slice(idx, 1)
              }
            })
          })
          console.log('Waiting Chats', state.waitingChats)
        }
      }
    }
  },
  [types.RESET_SERVICE_REQUEST](state) {
    state.serviceRequest = state.cleanServiceRequest
  },
  [types.SET_SERVICE_REQUEST](state, data) {
    state.serviceRequest = state.cleanServiceRequest
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.serviceRequest = data[0]
      }
    }
  },
  [types.SET_EDIT_STATUS](state, action) {
    state.requests.forEach(request => {
      request.isEditingStatus = false
      if (action > 0) {
        if (parseInt(request.workOrderId) === parseInt(action)) {
          request.isEditingStatus = true
        }
      }
    })
  },
  [types.SET_CHAT_STATUS](state, channel) {
    if (state.requests.length > 0) {
      state.requests.forEach(request => {
        if (parseInt(request.workOrderId) === parseInt(channel)) {
          request.isChatting = true
          request.isChat = false
          console.log('incoming message for ', { id: channel, item: request })
          if (request.status === 'Waiting on Shop' || request.status === 'Submitted') {
            request.isChat = true
            request.isChatting = false
            console.log('Found a "Waiting on Shop" or "Submitted" work order having an incoming message.')
            // state.waitingChat
            if (state.waitingChats.indexOf(channel) < 0) {
              state.waitingChats.push(channel)
            }
            console.log('Waiting Chats', state.waitingChats)
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/astechhub/mutations.js